import React, { Component } from 'react';
import {connect} from 'react-redux'
import PropTypes from 'prop-types';

const plural = (value, title) =>{
  let array = title.split('/')
  let mTitle = array[0] + (((value === 0 || value > 1) && array[1] !== undefined )? array[1]: '')
  return mTitle
}

const getHour = (date) => {
  const mDate = new Date(date)
  return (mDate.toLocaleTimeString(navigator.language, {hour: '2-digit', minute:'2-digit'}))
}

const diff = (dateA, dateB) => {
  const d = new Date(dateA).getTime() - new Date(dateB).getTime()
  const mDate = new Date(d)
  const h = mDate.getUTCHours().toLocaleString('es-ES', {minimumIntegerDigits: 2, useGrouping:false})
  const m = mDate.getUTCMinutes().toLocaleString('es-ES', {minimumIntegerDigits: 2, useGrouping:false})
  //console.log(timezone)
  return (`${h}:${m}` )
}

class Travel extends Component {
  static contextTypes = {
    router: PropTypes.object
  }

  onClickOption = (index) => {
    const {select, onClickOption} = this.props
    if (select){
        onClickOption(index)
    }
  }

  render() {
    const ships = ['El Dajzair II', 'Tassili II', 'Tariq', 'Elyros'];
    const langUrl = this.context.router.route.location.pathname.split('/')[1]
    const { languages } = this.props.settings
    const langPlace = languages[langUrl].search.travel
    const langTabs = languages[langUrl].fastbooking.tabs

    const {select, onClickTravel, nPassangers, nVehicles} = this.props
    const {prices, departure, arrival, origin, destination } = this.props

    const props = (!select)? {onClick: onClickTravel}: {}
    const classname = (select) ? 'row list-panel list-panel-select': 'row list-panel'

    const passangers = nPassangers + ' ' + plural(nPassangers, langTabs.passengers)
    const vehicles = nVehicles + ' ' + plural(nVehicles, langTabs.vehicles)

    return (
      <div className={classname} {...props} >
        <div className='col-lg-12 col-md-12 col-sm-12 col-xs-12'>
          <div className='row '>
            <div className='col-lg-2 col-md-2 col-sm-3 col-xs-6 align-vertical'>
              <div>
                <p className='title'>{langPlace.departure}</p>
                <p className='subtitle'>{getHour(departure)} {origin.name}</p>
              </div>
            </div>
            <div className='col-lg-2 col-md-2 col-sm-5 col-xs-6 no-padding align-vertical'>
              <div>
                <p className='title'>{langPlace.arrival}</p>
                <p className='subtitle'>{getHour(arrival)} {destination.name}</p>
              </div>
            </div>
            <div className='col-lg-1 col-md-1 col-sm-3 col-xs-6 no-padding align-vertical'>
              <div>
                <p className='title'>{langPlace.duration}</p>
                <p className='subtitle'>{`${diff(arrival, departure)} h`} </p>
              </div>
            </div>
            <div className='col-lg-2 col-md-2 col-sm-3 col-xs-6 no-padding align-vertical'>
              <div>
                <p className='title'>{langPlace.boatname}</p>
                <p className='subtitle'>{ships[Math.floor(Math.random() * ships.length)]}</p>
              </div>
            </div>
            <div className='col-lg-3 col-md-3 col-sm-6 col-xs-6 no-padding align-vertical'>
              <div>
                <p className='title'>{langPlace.Reservation}</p>
                <p className='subtitle'>{passangers} y {vehicles}</p>
              </div>
            </div>
            <div className='col-lg-2 col-md-2 col-sm-4 col-xs-6 selection-precio'>
              <div className='row' >
                <div className='col-md-9 col-sm-9 no-padding align-vertical'>
                  <p className='total'>
                    {`${prices.price.toLocaleString('es-ES',{minimumFractionDigits: 2})}€`}
                  </p>
                </div>
                <div className='col-md-3 col-sm-3 align-vertical check'>
                  {(select)?
                    <i className="fa fa-check" aria-hidden="true"></i>
                  :undefined}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
	(state) => ({settings: state.settings})
)(Travel)



// WEBPACK FOOTER //
// ./src/shared/routes/routeSearch/components/travel.js